import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Bar } from 'vue-chartjs';

@Component({})
export default class BarChart extends Mixins(Bar) {
  @Prop() public title!: string;
  @Prop() public labels!: string[];
  @Prop() public values!: number[];
  @Prop() public additionalData: number[];
  @Prop() public yAxisLabel: string;

  public mounted(): void {
    this.createChart();
  }

  public update(labels: string[], values: number[]): void {
    this.labels = labels;
    this.values = values;
    this.createChart();
  }

  private createChart(): void {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: this.title,
          backgroundColor: '#00a4ff',
          data: this.values,
        },
      ],
    }, {
      responsive: true,
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: this.yAxisLabel,
          },
          ticks: {
            beginAtZero: true,
            callback: (value: number): number|undefined => {
              if (value % 1 === 0) {
                return value;
              }
            },
          },
        }],
      },
      tooltips: {
        callbacks: {
          afterBody: (t, d) => {
            if (this.additionalData) {
              return `Calculated From ${this.additionalData[t.values().next().value.index]} Chats`;
            }

            return '';
          },
        },
      },
    });
  }
}
